<template>
  <div class="aliex-swiper">
    <div class="swiper-list">
      <div class="aliex-swipe" v-for="(item,index) in images" :key="index">
        <img :src="item" alt />
      </div>
    </div>
    <div class="circle">
      <span v-for="i in images.length" :key="i" :class="{active:active===i}"></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    images: {
      default: () => [],
      type: Array
    },
    timer: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      ind: 1,
      el: null,
      swiper: null,
      len: 0,
      currentIndex:0,
      active:1
    }
  },
  created() {
    // console.log(this.images)
  },
  computed: {
    ...mapGetters(['isDirection'])
  },
  methods: {
    start(el,swiper){ 
      if(this.isDirection){
        this.rtlSwiper(el,swiper)
      }else{
        this.ltrSwiper(el,swiper)
      }
    },
    rtlSwiper(el,swiper){
      this.currentIndex++;
      this.active++;
      if(this.currentIndex===this.images.length){
        this.active = 1
      }
      if(this.currentIndex>this.images.length){
        this.currentIndex = 0
        this.active = 1
        swiper.style.right = 0 +'px'
        swiper.style.transition = "none";
        return
      }
      swiper.style.transition = 'all .5s'
      swiper.style.right = -this.currentIndex*el.offsetWidth+'px'
    },
    ltrSwiper(el,swiper){
      this.currentIndex++;
      this.active++;
       if(this.currentIndex===this.images.length){
        this.active = 1
      }
      if(this.currentIndex>this.images.length){
        this.currentIndex = 0;
        this.active = 1
        swiper.style.left =  0+'px'
        swiper.style.transition = "none";
        return
      }
      swiper.style.transition = 'all .5s'
      swiper.style.left = -this.currentIndex*el.offsetWidth+'px'
    }
  },
  mounted() {
    this.el = document.querySelectorAll('.aliex-swipe')[0];
    this.swiper = document.querySelector('.swiper-list'); 
    let firstImg = this.swiper.firstElementChild.cloneNode(true)
    this.swiper.appendChild(firstImg)
    this.swiper.style.transition = 'all .5s'
    if(this.isDirection){
      this.swiper.style.right =  0+'px'
    }else{
      this.swiper.style.left =  0+'px'
    }
    setInterval(()=>{
      this.start(this.el,this.swiper) 
    },3000)
  }
}
</script>

<style lang="scss" scoped>
@import "../style/mixin";
@import "../assets/css/variableName";
[dir='rtl'] .swiper-list{
  right: 0;
}
[dir='ltr'] .swiper-list{
  left: 0;
}
.aliex-swiper {
  width: 100%;
  overflow: hidden;
  height: 100%;
  position: relative;
  .swiper-list {
    position: absolute;
    // display: flex;
    // white-space: nowrap;
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    transition:all .5s;
  }
  .aliex-swipe {
    // width: 100%;
    height: 100%;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.circle{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  .active{
      background: #FFC72B;
    }
  span{
    display: inline-block;
    width: torem(4);
    height: torem(4);
    background: #BCBCBC;
    margin: 0 torem(4);
    border-radius: 50%;
    
  }
  bottom: torem(6);
}
</style>


// WEBPACK FOOTER //
// src/compontents/swiper.vue